module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_1_null@2x.ca6d5fce.png";